(function () {
  const MOBILE_MQ = "(max-width: 991px)";

  function loadSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    const existing = document.querySelector('script[data-el-swiper="true"]');
    if (existing) {
      if (typeof Swiper !== "undefined") {
        callback();
        return;
      }
      existing.addEventListener("load", callback, { once: true });
      // Fallback if load already fired
      existing.addEventListener(
        "error",
        () => {},
        { once: true }
      );
      if (existing.dataset.loaded === "true") callback();
      return;
    }

    if (!document.querySelector('link[data-el-swiper-css="true"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
      link.dataset.elSwiperCss = "true";
      document.head.appendChild(link);
    }

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.dataset.elSwiper = "true";
    script.addEventListener(
      "load",
      () => {
        script.dataset.loaded = "true";
        callback();
      },
      { once: true }
    );
    document.body.appendChild(script);
  }

  function toggleProgress(swiper, progress) {
    if (!progress) return;
    const shouldShow = Boolean(swiper) && !swiper.isLocked;
    progress.hidden = !shouldShow;
    progress.classList.toggle("is-visible", shouldShow);
  }

  function destroySwiper(section) {
    if (section._elBenefitsSwiper) {
      section._elBenefitsSwiper.destroy(true, true);
      delete section._elBenefitsSwiper;
    }
  }

  function initBenefits(section) {
    const slider = section.querySelector(".el-benefits__blocks");
    const progress = section.querySelector(".el-benefits__progress");
    if (!slider) return;

    const isMobile = window.matchMedia(MOBILE_MQ).matches;

    if (!isMobile) {
      destroySwiper(section);
      toggleProgress(null, progress);
      return;
    }

    if (typeof Swiper === "undefined") return;

    if (section._elBenefitsSwiper) {
      section._elBenefitsSwiper.update();
      toggleProgress(section._elBenefitsSwiper, progress);
      return;
    }

    section._elBenefitsSwiper = new Swiper(slider, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: progress
        ? {
            el: progress,
            type: "progressbar",
          }
        : undefined,
      breakpoints: {
        581: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
        },
      },
      on: {
        init(instance) {
          toggleProgress(instance, progress);
        },
        resize(instance) {
          toggleProgress(instance, progress);
        },
        breakpoint(instance) {
          toggleProgress(instance, progress);
        },
      },
    });
  }

  function boot(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-benefits]").forEach((section) => {
      initBenefits(section);
    });
  }

  let resizeTimer;
  window.addEventListener(
    "resize",
    () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => boot(), 120);
    },
    { passive: true }
  );

  loadSwiper(() => boot());

  document.addEventListener("shopify:section:load", (event) => {
    loadSwiper(() => boot(event.target));
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector?.("[data-el-benefits]") || event.target;
    if (section?.matches?.("[data-el-benefits]") || section?.querySelector?.("[data-el-benefits]")) {
      const target = section.matches?.("[data-el-benefits]")
        ? section
        : section.querySelector("[data-el-benefits]");
      if (target) destroySwiper(target);
    }
  });
})();
